import { render, staticRenderFns } from "./TabAttributes.vue?vue&type=template&id=28e68385&"
import script from "./TabAttributes.vue?vue&type=script&lang=js&"
export * from "./TabAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports